module.exports = "./assets/assets/代理协议模板.a26c1b79.docx";